export const GET_SIMPLE_WEAPON_PENDING = "GET_SIMPLE_WEAPON_PENDING";
export const GET_MORE_SIMPLE_WEAPON_PENDING = "GET_MORE_SIMPLE_WEAPON_PENDING";
export const GET_SIMPLE_WEAPON_SUCCESS = "GET_SIMPLE_WEAPON_SUCCESS";
export const GET_MORE_SIMPLE_WEAPON_SUCCESS = "GET_MORE_SIMPLE_WEAPON_SUCCESS";
export const RESET_SIMPLE_WEAPON = "RESET_SIMPLE_WEAPON";
export const GET_HOME_WEAPON = "GET_HOME_WEAPON";
export const RESET_HOME_WEAPON = "RESET_HOME_WEAPON";
